// extracted by mini-css-extract-plugin
module.exports = {"course-unit-subtitle":"video-courses-fallback-carousel_course-unit-subtitle__TPWSg"};